import React from 'react';
import Typography from '@mui/material/Typography';
import { version_num } from './config';

const Copyright = (props) => {
    return (
        <div id="copyright-footer" className="w-100 tc absolute bottom-1">
            <Typography
                variant="body1"
                color="black"
                align="center"
                sx={{
                    textShadow: `
                        0 0 4px #ffffff,
                        0 0 8px #ffffff,
                        0 0 12px #ffffff
                    `,
                }}
                {...props}
            >
                <strong>
                    {'The Wake Up Safe Case Reporting system (' + version_num + ') Powered by '}
                    the Children's Hospital of Philadelphia
                    {' © ' + new Date().getFullYear()}
                    {'.'}
                </strong>
            </Typography>
        </div>
    );
};

export default Copyright;
